import type { HebrewDayInfo } from "@kedaat/engine";

export interface HolyPeriod {
  /** From Erev Shabbat or Yom Tov through the day it ends. */
  days: HebrewDayInfo[];
  start: HebrewDayInfo;
  end: HebrewDayInfo;
  title: string;
}

/**
 * Groups days into Shabbat and Yom Tov periods, each from its eve (candle lighting) through
 * the day it ends. Periods cut off by the start or end of the given days are left out.
 */
export function holyPeriods(days: HebrewDayInfo[]): HolyPeriod[] {
  const periods: HolyPeriod[] = [];
  let current: HebrewDayInfo[] | null = null;
  for (const day of days) {
    if (!current) {
      if (day.candleLightingTonight && !day.isShabbatOrYomTov) current = [day];
      continue;
    }
    current.push(day);
    if (day.endsTonight) {
      periods.push({
        days: current,
        start: current[0]!,
        end: day,
        title: titleOf(current.slice(1)),
      });
      current = null;
    }
  }
  return periods;
}

function titleOf(holyDays: HebrewDayInfo[]): string {
  const names: string[] = [];
  for (const day of holyDays) {
    const name = day.parsha
      ? `פרשת ${day.parsha}${day.specialShabbat ? ` (שבת ${day.specialShabbat})` : ""}`
      : (day.holiday ?? "שבת");
    if (!names.includes(name)) names.push(name);
  }
  return names.join(" · ");
}
